export const GUIDES = [
    {
        slug: "monzo", bank: "Monzo", app: "Monzo app", format: "CSV",
        intro: "Monzo makes exporting easy: you can download a CSV of any date range straight from the app in under a minute.",
        steps: [
            "Open the Monzo app and tap your account balance at the top to open the account screen.",
            "Scroll down and tap Statements (or Manage → Statements).",
            "Choose a date range — pick at least the last 3 months so Sift can compare against your usual spending.",
            "Tap Export and choose CSV (a PDF also works, but CSV is more accurate).",
            "Share the file to yourself (AirDrop, email, Files) and upload it to Sift.",
        ],
        tips: ["Monzo CSVs include Category and Notes columns — Sift uses the Description and Amount columns and ignores the rest.", "If you have Pots, transfers into them show as 'Transfers & Savings', not spending."],
    },
    {
        slug: "starling", bank: "Starling Bank", app: "Starling app", format: "CSV",
        intro: "Starling lets you download statements per month or a custom range as CSV, PDF or QIF from the app or online banking.",
        steps: [
            "In the Starling app, tap the account you want, then the Menu (three lines) and choose Statements & Downloads.",
            "Pick a month, or choose Custom to set a longer range (3+ months recommended).",
            "Select CSV as the format.",
            "Tap Download and save or share the file.",
            "Upload the CSV to Sift — Starling's Counter Party and Amount (GBP) columns are detected automatically.",
        ],
        tips: ["Starling shows money in as positive and money out as negative — exactly what Sift expects.", "Spaces (savings goals) transfers are categorised as savings, not spending."],
    },
    {
        slug: "barclays", bank: "Barclays", app: "Barclays app or Online Banking", format: "CSV / OFX / PDF",
        intro: "Barclays lets you export transactions from Online Banking; the app supports PDF statements which Sift can also read.",
        steps: [
            "Log in to Barclays Online Banking on a computer and select your current account.",
            "Click Statements & documents, then Export/Download transactions (the download icon next to the transaction list).",
            "Choose a date range — up to 3 months per export; run it a few times for more history.",
            "Pick Excel/CSV as the format and save the file.",
            "Upload to Sift. Barclays' Money In / Money Out columns are combined into a single signed amount automatically.",
        ],
        tips: ["Barclays PDF statements from the app also work — Sift reads them with AI, but CSV is faster and more accurate.", "Barclaycard is a separate export from the Barclaycard app/site."],
    },
    {
        slug: "hsbc", bank: "HSBC", app: "HSBC UK app or Online Banking", format: "CSV / PDF",
        intro: "HSBC offers CSV downloads of recent transactions through Online Banking, and PDF statements through both the app and website.",
        steps: [
            "Log in to HSBC Online Banking and open your current account.",
            "Above the transaction list choose Download transactions (or the download arrow).",
            "Select a range of up to 90 days and choose CSV / Spreadsheet.",
            "Save the file (it's usually called TransHist.csv).",
            "Upload it to Sift. Repeat for older periods if you want longer comparisons.",
        ],
        tips: ["HSBC CSVs have Date, Description and Amount columns with money out as negative — no changes needed.", "In the app: Statements → choose a month → Download PDF also works."],
    },
    {
        slug: "lloyds", bank: "Lloyds Bank", app: "Lloyds app or Internet Banking", format: "CSV / QIF / PDF",
        intro: "Lloyds (and Halifax / Bank of Scotland, which use the same system) lets you export statements as CSV via Internet Banking.",
        steps: [
            "Log in to Lloyds Internet Banking and open the account.",
            "Click Export (top of the statement) — you can also find it under Statements.",
            "Choose the date range (up to a few months at a time) and the format Internet banking text/spreadsheet (.CSV).",
            "Click Export and save the file.",
            "Upload the CSV to Sift; the Debit Amount and Credit Amount columns are merged automatically.",
        ],
        tips: ["Works the same for Halifax and Bank of Scotland.", "Lloyds' Transaction Type column (DEB, DD, FPO…) is ignored — Sift categorises from the description."],
    },
    {
        slug: "natwest", bank: "NatWest", app: "NatWest app or Online Banking", format: "CSV / PDF",
        intro: "NatWest (and RBS / Ulster Bank) export statements to CSV from Online Banking, with PDF statements in the app.",
        steps: [
            "Log in to NatWest Online Banking and choose the account.",
            "Select Statements, then Download or export transactions.",
            "Set the date range (12 months available) and pick CSV / Excel as the format.",
            "Download and save the file.",
            "Upload it to Sift — NatWest's Date, Description and Value columns are recognised automatically.",
        ],
        tips: ["Same steps apply for RBS and Ulster Bank.", "NatWest sometimes adds quote marks around descriptions — that's fine, Sift strips them."],
    },
];
